import { createAction } from 'redux-actions';
import moment from 'moment';
import api from '../../../../utils/apiClient';

export const fetchTodoListDataRequest = createAction('FETCH_TODO_LIST_DATA_REQUEST');
export const fetchTodoListDataSuccess = createAction('FETCH_TODO_LIST_DATA_SUCCESS');
export const fetchTodoListDataFailure = createAction('FETCH_TODO_LIST_DATA_FAILURE');
export const updateTodoListData = createAction('UPDATE_TODO_LIST_DATA');

export const fetchTodoListData = (data, header) => async (dispatch) => {
  try {
    dispatch(fetchTodoListDataRequest());
    const response = await api.todo.getTodoData(data, header);
    const todoListData = response.data;
    dispatch(fetchTodoListDataSuccess(todoListData));
  } catch (error) {
    dispatch(fetchTodoListDataFailure({ error }));
    throw error;
  }
};

const processError = (todoElementData, error, getState) => {
  const todoListCopy = getState().todo && getState().todo.data && getState().todo.data.elements
    && [...getState().todo.data.elements];
  const elementIndex = todoListCopy.findIndex(e => e.data.id === todoElementData.id);
  todoListCopy[elementIndex] = {
    data: todoElementData,
    isEdit: false,
    isFetching: false,
    error,
  };
  return todoListCopy;
};

const updateTodoElementData = (newTodoElementData, getState) => {
  const todoListCopy = [...getState().todo.data.elements];
  const elementIndex = todoListCopy.findIndex(e => e.data.id === newTodoElementData.id);
  todoListCopy[elementIndex] = {
    data: newTodoElementData,
    isEdit: false,
    isFetching: false,
    error: null,
  };
  return todoListCopy;
};

export const editTodoElement = (value, header) => async (dispatch, getState) => {
  let updatedTodoList = [];
  try {
    updatedTodoList = updateTodoElementData(value, getState);
    await api.todo.setTodoData(value, null, header);
    dispatch(updateTodoListData(updatedTodoList));
  } catch (error) {
    updatedTodoList = processError(value, error, getState);
    dispatch(updateTodoListData(updatedTodoList));
    throw error;
  }
};

export const deleteTodoElement = (id, header) => async (dispatch, getState) => {
  const todoDataCopy = getState().todo && getState().todo.data && { ...getState().todo.data };
  const todoListCopy = [...todoDataCopy.elements];
  const elementIndex = todoListCopy.findIndex(e => e.data.id === id);
  const deleteItem = todoListCopy[elementIndex];
  deleteItem.data.status = 'delete';
  await api.todo.setTodoData(deleteItem.data, null, header);
  todoListCopy.splice(elementIndex, 1);
  dispatch(updateTodoListData(todoListCopy));
};

export const addTodoElement = (newElementData, header) => async (dispatch, getState) => {
  const todoDataCopy = getState().todo && getState().todo.data && { ...getState().todo.data };
  const todoListCopy = [...todoDataCopy.elements];
  const newRow = await api.todo.setTodoData(newElementData, null, header);
  todoListCopy.unshift({
    data: {
      id: newRow.data[0].id,
      title: newRow.data[0].title,
      description: newRow.data[0].description,
      isCompleted: newRow.data[0].is_completed,
      isArchived: newRow.data[0].is_archived,
      priority: newRow.data[0].priority,
      dueDate: moment(newRow.data[0].due_date).format('MM/DD/YYYY'),
      submittedDate: moment(newRow.data[0].submitted_date).format('MM/DD/YYYY'),
      accountId: newRow.data[0].account_id,
      assignedToEmail: newRow.data[0].assigned_to_email,
      submittedByEmail: newRow.data[0].submitted_by_email,
      status: newRow.data[0].status,
    },
    isEdit: false, // maybe you will need to make it true, depends on your logic
    isFetching: false,
    error: null,
  });
  dispatch(updateTodoListData(todoListCopy));
};
